import { render, staticRenderFns } from "./RedWallet.vue?vue&type=template&id=19e313e5"
import script from "./RedWallet.vue?vue&type=script&lang=js"
export * from "./RedWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports